export enum IntensityOfReaction { 
    HighIntensity = 1,
    LowIntensity = 3
    }